import { useTranslation } from 'react-i18next';
import styles from './FilterTag.module.scss';
import classNames from 'classnames';

interface FilterTagProps {
  tag: string;
  Icon: React.FC<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  iconStroke?: string;
  disabled?: boolean;
  checked: boolean;
  onChange: (tag: string) => void;
  onClick?: () => void;
}

export default function FilterTag({
  tag,
  Icon,
  iconStroke,
  disabled,
  checked,
  onChange,
  onClick,
}: Readonly<FilterTagProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.root, checked && styles.checked)}>
      <input
        className={styles.input}
        type='radio'
        name='tag'
        value={tag}
        id={tag}
        disabled={disabled}
        checked={checked}
        onChange={() => onChange(tag)}
        onClick={onClick}
      />
      <Icon
        className={styles.icon}
        stroke={iconStroke}
      />
      <label
        className={styles.label}
        htmlFor={tag}
      >
        {t(`tags.${tag}`)}
      </label>
    </div>
  );
}
